export function axIsCallable(value) {
    return (value && typeof value.axApply === 'function');
}
